<div class="gains-colored-text-cell" [ngClass]="className" [style.backgroundColor]="backgroundColor" [style.borderColor]="borderColor">
  <svg-icon *ngIf="showIcon && icon" [src]="'assets/icons/' + icon" [style.color]="iconColor" class="cell-icon"> </svg-icon>
  <span *ngIf="showText && text" class="cell-text" [style.color]="textColor">
    {{ text }}
  </span>
</div>
